const mainTitleBarMessages = {
  'mainTitleBar.menu.dashboard': 'ダッシュボード',
  'mainTitleBar.menu.media': '写真一覧',
  'mainTitleBar.menu.report': '報告書一覧',
  'mainTitleBar.menu.issue': 'ログイン用QR',
  'mainTitleBar.menu.staff': 'ユーザー管理',
  'mainTitleBar.menu.company': '企業管理',
  'mainTitleBar.menu.device': 'デバイス管理',
  'mainTitleBar.menu.master': 'タグセット管理',
  'mainTitleBar.menu.settings': '設定',
  'mainTitleBar.menu.summary': '一覧',
  'mainTitleBar.menu.group': 'グループ管理',
  'mainTitleBar.menu.actionLog': 'アクティビティログ',
  'mainTitleBar.menu.accessControl': 'アクセス制御',
  'mainTitleBar.menu.termsOfServices': '利用規約',
  'mainTitleBar.menu.privacyPolicy': 'プライバシーポリシー',
  'mainTitleBar.message.licenseExceeded.sp':
    'ライセンスを超過している企業があります！',
  'mainTitleBar.message.licenseExceeded.other':
    'ライセンス数が超過しています！{excessItems}',
  'mainTitleBar.message.licenseExceeded.other.userLicenseInfo': '【ユーザ数】',
  'mainTitleBar.message.licenseExceeded.other.storageLicenseInfo':
    '【ストレージ使用量({storageExcessValue})】',
  'mainTitleBar.message.licenseExceeded.other.remoteSupportLicenseInfo':
    '【遠隔作業支援数】',
  'mainTitleBar.message.licenseExceeded.other.storageExcessValue':
    '{excessValue}超過',
  'mainTitleBar.button.callingRooms': '通話中',
};

export default mainTitleBarMessages;
